import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Skeleton } from '@mui/material';

import { VpIcon } from './';

// styles
const thumbnailContainerStyles = {
  height: '42px',
  width: '42px',
  borderRadius: '4px',
  display: 'grid',
  overflow: 'hidden'
};

const mediaStyles = {
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'cover',
  minWidth: '100%',
  minHeight: '100%'
};
const iconStyles = {
  ...thumbnailContainerStyles,
  justifyContent: 'center',
  alignContent: 'center',
  backgroundColor: 'vpColors.greyLight'
};
const skeltonStyles = {
  width: '100%',
  height: '100%',
  position: 'absolute'
};

export const VpMediaIcon = ({ media, ...rest }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const src = media?.thumbnailUrl || media?.path;

  const boxStyles = {
    ...thumbnailContainerStyles,
    position: 'relative',
    backgroundColor: !isLoading && !hasError ? 'vpColors.black' : '',
    alignItems: 'center'
  };

  const onLoad = () => {
    setIsLoading(false);
  };
  const onError = () => {
    setHasError(true);
  };

  if (hasError) {
    return (
      <Box sx={iconStyles} {...rest}>
        <VpIcon icon="Paperclip" />
      </Box>
    );
  }

  return (
    <Box sx={boxStyles} {...rest}>
      {isLoading && <Skeleton sx={skeltonStyles} variant="rectangular" />}
      <Box
        key={media?.id}
        component="img"
        onLoad={onLoad}
        src={src}
        sx={mediaStyles}
        onError={onError}
      />
    </Box>
  );
};

VpMediaIcon.propTypes = {
  media: PropTypes.object
};

export default VpMediaIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpMediaIcon.jsx